import React, { useState, useEffect, useCallback } from 'react';
import Banner from '../../ui/Banner';
import LiveChatWidget from '../chatWidget/LiveChatWidget';
import axios from '../../api/axios';

function ShowChatWidget() {
  const [showChat, setShowChat] = useState(false);
  const [myTickets, setMyTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(true);
  const contactEmail = process.env.REACT_APP_CONTACT_US || 'support@fpgtechnology.com';

  // Fetch user's own tickets for the quick status panel
  const fetchMyTickets = useCallback(async () => {
    setTicketsLoading(true);
    try {
      const res = await axios.get('/support/tickets', { params: { limit: 5 } });
      if (res.data.success) setMyTickets(res.data.data);
    } catch (err) {
      console.error('[HelpCenter] fetchMyTickets error:', err);
    } finally {
      setTicketsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMyTickets();
  }, [fetchMyTickets]);

  // Refresh ticket list when chat widget closes
  const handleChatClose = () => {
    setShowChat(false);
    fetchMyTickets();
  };

  return (
    <>
      {/* Live Chat Widget (floating) */}
      {showChat && <LiveChatWidget onClose={handleChatClose} />}

      {/* Chat Bubble Button (always visible after first open) */}
      <button
        id="chat-bubble-btn"
        className="hc-chat-bubble"
        onClick={() => setShowChat(!showChat)}
        title={showChat ? 'Close Support Chat' : 'Open Support Chat'}
      >
        <i className={showChat ? 'fas fa-times' : 'fas fa-comment-dots'} />
      </button>
    </>
  );
}

export default ShowChatWidget;
